<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section">
    <div class="row">
      <div class="col-sm-12 col-md-5 col-lg-4 col-xl-3">
        <div class="list-of-country align-start">
          <h3>Motherline Distribution</h3>
          <br />
          <!-- <router-link
                                            :to="{
                                                name: 'motherline-distribution-map',
                                                params: { region: d.id },
                                            }"
                                            v-for="d in motherlineStore.result.distribution.map(
                                                ({ title, percentage, id }) => ({
                                                    title,
                                                    percentage,
                                                    id,
                                                })
                                            )"
                                            class="flex justify-between no-underline px-4 py-1 rounded"
                                            :class="
                                                d.id === $route.params.region
                                                    ? 'bg-gray-100'
                                                    : 'hover:bg-gray-50'
                                            "
                                        >
                                            <div class="flex items-center space-x-2">
                                                <div
                                                    class="rounded-full bg-rose-500 h-3 w-3 opacity-25"
                                                />
                                                <div>{{ d.title }}</div>
                                            </div>
                                            <div class="flex items-center space-x-2">
                                                <div>{{ d.percentage }}%</div>
                                                <FeatherWrapper
                                                    icon="chevron-right"
                                                    class="text-gray-600"
                                                />
                                            </div>
                                        </router-link> -->
          <div class="">
            <ul class="mother-active">
              <router-link
                :to="{
                  name: 'motherline-distribution-map',
                  params: { region: d.id },
                }"
                v-for="d in motherlineStore.result.distribution.map(
                  ({ title, percentage, id }) => ({
                    title,
                    percentage,
                    id,
                  })
                )"
                :key="d.id"
                class="flex justify-between no-underline px-4 py-1 rounded"
              >
                <li>
                  <button
                    @click="selectRegion(d.id)"
                    :class="
                      d.id === selectedRegion
                        ? 'motherline-selected-map-option'
                        : 'unselected-map-option'
                    "
                  >
                    <div class="custom-name">
                      <span>{{ d.percentage.toFixed(1) }}%</span>
                      <label>{{ d.title }}</label>
                    </div>
                  </button>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-7 col-lg-8 col-xl-9" id="comments-section">
        <div class="map-wrap">
          <div class="col-sm-12 mb-4">
            <div class="card-section">
              <h4 class="fs-3 text-black text-start fw-bolder mb-3">
                Motherline Distribution Map
              </h4>
              <p class="text-start mb-1">
                You're viewing your distribution map which shows you where
                people who share your haplogroup live today.
              </p>
              <p class="text-start">
                Your distribution map shows you where in the world today people
                with your maternal haplogroup are living. The percentage
                represents the number of people in that region who share your
                haplotype.
              </p>
            </div>
          </div>
          <div class="col-sm-12">
            <DistributionMap
              v-if="showMap"
              v-model="selectedRegion"
              :coverage-data="stagedCoverageData"
              :gender="'motherline'"
              class="img-fluid rounded-4 w-100"
            />

            <!-- <img
                                                src="../../../assets/images/ancetry/white-graph.png"
                                                class="img-fluid rounded-4 w-100"
                                            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import { useMotherlineStore } from "@/store/parentalStore";
// import Sidebar from "@/components/Sidebar.vue";
import { ref, onMounted, watchEffect } from "vue";
// import FeatherWrapper from "@/components/feather/FeatherWrapper.vue";
import DistributionMap from "@/components/ancestry/DistributionMap.vue";
// import MobileContent from "@/components/ancestry/MobileContent.vue";
import { useRoute } from "vue-router";
const showMap = ref(false);
const loadingStatus = ref("loading");
const stagedCoverageData = ref();


setTimeout(() => {
  showMap.value = true;
}, 500);

const route = useRoute();
const selectedRegion = ref(route.params.region || null);
const motherlineStore = useMotherlineStore();
// const activeRegion = computed(() => {
//     return motherlineStore.result.distribution.find((d) => d.id === route.params.region);
// });

const selectRegion = (regionId) => {
  selectedRegion.value = regionId;
  updateStagedCoverageData();
  scrollToCommentsSection();
};

const scrollToCommentsSection = () => {
  const commentsSection = document.getElementById("comments-section");
  if (commentsSection) {
    commentsSection.scrollIntoView({ behavior: "smooth" });
  }
};

onMounted(async () => {
  try {
    await motherlineStore.getResult();
    if (!motherlineStore.result) {
      throw new Error("No result");
    }
    console.log("Result fetched:", motherlineStore.result);
    updateStagedCoverageData();
  } catch (error) {
    console.error(error);
  }
});

const updateStagedCoverageData = () => {
  if (motherlineStore.result?.distribution) {
    stagedCoverageData.value = {
      type: "geojson",
      data: {
        id: "coverageMapData",
        type: "FeatureCollection",
        features: motherlineStore.result.distribution
          .map(({ geoJson, ...properties }) => ({
            ...JSON.parse(geoJson),
            id: properties.id,
            properties,
          }))
          .filter((el) => el.geometry !== undefined),
      },
    };
    loadingStatus.value = "loaded";
    console.log("Staged coverage data updated:", stagedCoverageData.value);
  } else {
    console.error("No distribution data found in result.");
  }
};

// Watch for changes in motherlineStore.result and update stagedCoverageData accordingly
watchEffect(
  () => motherlineStore.result,
  (newResult) => {
    if (newResult) {
      updateStagedCoverageData();
    }
  }
);
</script>
